import {CacheApiCache} from './cacheapi';
import {type LongTermCache} from './types';

const globalCache = new CacheApiCache();

// Keep cache selection behind one entry point so callers do not depend on the
// storage implementation.
export function getCache(): LongTermCache {
  return globalCache;
}
